import React from 'react'

export const REACT_MAJOR_VERSION = parseInt(React.version.split('.')[0], 10)
